import ConsultantSearchContainer from './ConsultantSearchContainer';
export default ConsultantSearchContainer;